import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import Constants from "../../caseLawDocuments/common/Constants";
import { IDocumentTypeIndexCategory } from "../../documentTypes/model/DocumentTypeIndexCategory";
import DocumentTypeIndexCategoryParamMapper from "../../documentTypes/service/DocumentTypeIndexCategoryParamMapper";

export default class AddCaseLawDocumentTypeIndexCategoriesInteractor {
  private createListResource: CreateListResourceInteractor<IDocumentTypeIndexCategory>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(
    organisationCaseLawDocumentTypeList: IDocumentTypeIndexCategory[],
    caseLawDocumentTypeId: number,
    organisationId: number
  ) {
    return this.createListResource.execute(
      `${Constants.caseLawDocumentTypePath}/${caseLawDocumentTypeId}/organisations/${organisationId}`,
      organisationCaseLawDocumentTypeList,
      undefined,
      DocumentTypeIndexCategoryParamMapper
    );
  }
}
